
import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: '一般お問い合わせ',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.message.length > 500) {
      alert('メッセージは500文字以内で入力してください。');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('type', formData.type);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d63eidabdoed7v0v8ng0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          type: '一般お問い合わせ',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            お問い合わせ・出演依頼
          </h3>
          <div className="w-24 h-1 bg-[#ff1493] mx-auto rounded-full mb-6"></div>
          <p className="text-white/70 text-lg">
            番組へのご意見・ご感想、出演依頼などお気軽にどうぞ
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/10">
          <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
            <div className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-white font-medium mb-2">
                  お名前 <span className="text-[#ff1493]">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-[#ff1493] transition-colors text-base"
                  placeholder="山田太郎"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-white font-medium mb-2">
                  メールアドレス <span className="text-[#ff1493]">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-[#ff1493] transition-colors text-base"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label htmlFor="type" className="block text-white font-medium mb-2">
                  お問い合わせ種別 <span className="text-[#ff1493]">*</span>
                </label>
                <select
                  id="type"
                  name="type"
                  required
                  value={formData.type}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                  className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#ff1493] transition-colors text-base cursor-pointer"
                >
                  <option value="一般お問い合わせ" className="bg-[#1a2642] text-white">一般お問い合わせ</option>
                  <option value="出演依頼" className="bg-[#1a2642] text-white">出演依頼</option>
                  <option value="番組への感想" className="bg-[#1a2642] text-white">番組への感想</option>
                  <option value="取材依頼" className="bg-[#1a2642] text-white">取材依頼</option>
                  <option value="その他" className="bg-[#1a2642] text-white">その他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-white font-medium mb-2">
                  メッセージ <span className="text-[#ff1493]">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={6}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-[#ff1493] transition-colors resize-none text-base"
                  placeholder="お問い合わせ内容をご記入ください"
                ></textarea>
                <p className="text-white/50 text-sm mt-2">
                  {formData.message.length} / 500文字
                </p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-4 flex items-center gap-3">
                  <i className="ri-check-line text-2xl text-green-400"></i>
                  <p className="text-green-400">送信が完了しました。ありがとうございます！</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-4 flex items-center gap-3">
                  <i className="ri-error-warning-line text-2xl text-red-400"></i>
                  <p className="text-red-400">送信に失敗しました。もう一度お試しください。</p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#ff1493] text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-[#ff69b4] transition-all duration-300 shadow-lg hover:shadow-[#ff1493]/50 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    送信中...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-send-plane-line"></i>
                    送信する
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-[#ff1493]/20 rounded-full mx-auto mb-4">
              <i className="ri-user-star-line text-2xl text-[#ff1493]"></i>
            </div>
            <h5 className="text-white font-bold mb-2 whitespace-nowrap">出演者募集</h5>
            <p className="text-white/60 text-sm">インディーズアーティストの方、ぜひご出演ください</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-[#ffd700]/20 rounded-full mx-auto mb-4">
              <i className="ri-feedback-line text-2xl text-[#ffd700]"></i>
            </div>
            <h5 className="text-white font-bold mb-2 whitespace-nowrap">ご意見・ご感想</h5>
            <p className="text-white/60 text-sm">番組へのご意見やリクエストをお待ちしています</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-question-line text-2xl text-white"></i>
            </div>
            <h5 className="text-white font-bold mb-2 whitespace-nowrap">その他</h5>
            <p className="text-white/60 text-sm">取材依頼やコラボレーションのご相談など</p>
          </div>
        </div>
      </div>
    </section>
  );
}
